import { initChat, chat } from '@speareducation/talkjs';
import { extend, override } from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
import AvatarEditor from 'flarum/forum/components/AvatarEditor';
import Button from 'flarum/common/components/Button';
import avatar from 'flarum/common/helpers/avatar';

export default () => {
    extend(UserCard.prototype, 'infoItems', function(items) {
        const userId = this.attrs?.user?.data?.id;
        if (userId && app.session.user) {
            initChat(); // pre-fetch chat session

            async function openChat() {
                const chat = await initChat();
                const convo = await chat.oneOnOne(userId);
                const popover = chat.getPopover();
                popover.select(convo);
                popover.show();
            }

            items.add('chat', <Button className="Button Button--primary" onclick={openChat}>Send a Message</Button>, 50);
        }
    });

    // Users should not be able to edit avatars here. Only in MyAccount.
    override(AvatarEditor.prototype, 'view', function() {
      const { user } = this.attrs;
      return (
        <div>
          <div className="UserCard-avatar">{avatar(user, { loading: 'eager' })}</div>
        </div>
      )
    })
};
